import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";
import {
    SET_REQUEST_LIST, GET_REQUEST_LIST, SEARCH_REQUEST_BY_ID, SET_REQUEST_BY_ID,
    ADD_REQUEST, ADD_REQUEST_RESPONSE, UPDATE_REQUEST, UPDATE_REQUEST_RESPONSE, DELETE_REQUEST, DELETE_REQUEST_RESPONSE,
    SEARCH_REQUEST_BY_FIELD, APPROVE_REJECT_REQUEST, APPROVE_REJECT_REQUEST_RESPONSE, REQUEST_BY_FIELD_LIST
} from "./actionTypes";

export class GetRequestList implements Action {
    readonly type = GET_REQUEST_LIST;
}

export class SetRequestList implements Action {
    readonly type = SET_REQUEST_LIST;
    readonly payload = []
    constructor(customerList: Array<any>) {
        this.payload = customerList;
    }
}

export class SearchRequestById implements Action {
    readonly type = SEARCH_REQUEST_BY_ID;
    readonly payload: string = null;
    constructor(id) {
        this.payload = id
    }
}

export class SetRequestById implements Action {
    readonly type = SET_REQUEST_BY_ID;
    readonly payload = null;
    constructor(data) {
        this.payload = data
    }
}

export class SearchRequestByField implements Action {
    readonly type = SEARCH_REQUEST_BY_FIELD;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class RequestByFieldList implements Action {
    readonly type = REQUEST_BY_FIELD_LIST;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class AddRequest implements Action {
    readonly type = ADD_REQUEST;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data
    }
}

export class AddRequestResponse implements Action {
    readonly type = ADD_REQUEST_RESPONSE;
    readonly payload: any = null;
    constructor(resp: IServerResponse) {
        this.payload = resp;
    }
}

export class UpdateRequest implements Action {
    readonly type = UPDATE_REQUEST;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data
    }
}

export class UpdateRequestResponse implements Action {
    readonly type = UPDATE_REQUEST_RESPONSE;
    readonly payload: any = null;
    constructor(resp: IServerResponse) {
        this.payload = resp;
    }
}

export class DeleteRequest implements Action {
    readonly type = DELETE_REQUEST;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data
    }
}

export class DeleteRequestResponse implements Action {
    readonly type = DELETE_REQUEST_RESPONSE;
    readonly payload: any = null;
    constructor(resp: IServerResponse) {
        this.payload = resp;
    }
}

export class ApproveRejectRequest implements Action {
    readonly type = APPROVE_REJECT_REQUEST;
    readonly payload: any = null;
    constructor(data) {
        this.payload = data
    }
}

export class ApproveRejectRequestResponse implements Action {
    readonly type = APPROVE_REJECT_REQUEST_RESPONSE;
    readonly payload: any = null;
    constructor(resp: IServerResponse) {
        this.payload = resp;
    }
}


export type Actions = GetRequestList | SetRequestList | SearchRequestById | SetRequestById |
    AddRequest | AddRequestResponse | UpdateRequest | UpdateRequestResponse | DeleteRequest | DeleteRequestResponse |
    SearchRequestByField | RequestByFieldList | ApproveRejectRequest | ApproveRejectRequestResponse;
